/* Shopify predictive search section API; full-page GET form remains the fallback. */
(() => {
  function initializeHeader(header) {
    if (header.dataset.initialized) return;
    header.dataset.initialized = 'true';
    const desktop = header.querySelector('.ww-desktop-navigation');
    const disclosures = Array.from(desktop.querySelectorAll('details'));
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const menuButton = header.querySelector('[data-menu-open]');
    const searchDialog = header.querySelector('[data-search-dialog]');
    const input = searchDialog.querySelector('[data-predictive-input]');
    const results = searchDialog.querySelector('[data-predictive-results]');
    const status = searchDialog.querySelector('[data-predictive-status]');
    const discover = searchDialog.querySelector('[data-search-discover]');
    let timer;
    let controller;
    let requestSequence = 0;
    let activeIndex = -1;
    let searchOpener;
    const desktopQuery = window.matchMedia('(min-width: 1100px)');

    function closeDisclosures(except) {
      disclosures.forEach(detail => { if (detail !== except) detail.open = false; });
    }
    disclosures.forEach(detail => {
      detail.addEventListener('toggle', () => { if (detail.open) closeDisclosures(detail); });
    });
    document.addEventListener('click', event => {
      if (!desktop.contains(event.target)) closeDisclosures();
    });
    desktop.addEventListener('focusout', () => {
      window.setTimeout(() => { if (!desktop.contains(document.activeElement)) closeDisclosures(); }, 0);
    });
    desktop.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const open = disclosures.find(detail => detail.open);
      if (open) {
        event.preventDefault();
        open.open = false;
        open.querySelector('summary').focus();
      }
    });

    function updateScrollLock() {
      document.documentElement.classList.toggle('ww-dialog-open', mobileMenu.open || searchDialog.open);
    }
    [mobileMenu, searchDialog].forEach(dialog => {
      dialog.querySelectorAll('[data-dialog-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('close', updateScrollLock);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    });
    menuButton.addEventListener('click', () => {
      if (typeof mobileMenu.showModal !== 'function') { window.location.assign('/collections/dogs'); return; }
      mobileMenu.showModal();
      updateScrollLock();
    });
    mobileMenu.querySelectorAll('nav a, .ww-menu-help a').forEach(link => link.addEventListener('click', () => mobileMenu.close()));
    desktopQuery.addEventListener('change', event => {
      closeDisclosures();
      if (event.matches && mobileMenu.open) mobileMenu.close();
    });

    header.querySelectorAll('[data-search-open]').forEach(opener => {
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', searchDialog.id);
      opener.addEventListener('click', event => {
        if (typeof searchDialog.showModal !== 'function') return;
        event.preventDefault();
        searchOpener = mobileMenu.contains(opener) ? menuButton : opener;
        if (mobileMenu.open) mobileMenu.close();
        closeDisclosures();
        searchDialog.showModal();
        updateScrollLock();
        input.focus();
        if (input.value.trim()) scheduleSearch();
      });
    });
    searchDialog.addEventListener('close', () => {
      clearTimeout(timer);
      requestSequence++;
      if (controller) controller.abort();
      results.removeAttribute('aria-busy');
      if (searchOpener && searchOpener.isConnected) searchOpener.focus();
    });

    function options() { return Array.from(results.querySelectorAll('[data-predictive-option]')); }
    function selectOption(index) {
      const items = options();
      activeIndex = index;
      items.forEach((item, position) => item.setAttribute('aria-selected', String(position === index)));
      if (items[index]) {
        input.setAttribute('aria-activedescendant', items[index].id);
        items[index].scrollIntoView({ block: 'nearest' });
      } else input.removeAttribute('aria-activedescendant');
    }
    function resetResults() {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      input.setAttribute('aria-expanded', 'false');
      results.hidden = true;
      results.replaceChildren();
      results.removeAttribute('aria-busy');
    }
    function scheduleSearch() {
      clearTimeout(timer);
      if (controller) controller.abort();
      const sequence = ++requestSequence;
      const term = input.value.trim();
      resetResults();
      discover.hidden = term.length > 0;
      if (term.length < 2) {
        status.textContent = term.length ? 'Keep typing to see suggestions, or press Search.' : '';
        return;
      }
      status.textContent = 'Finding something lovely…';
      timer = window.setTimeout(() => fetchSuggestions(term, sequence), 220);
    }
    async function fetchSuggestions(term, sequence) {
      controller = new AbortController();
      const endpoint = new URL(searchDialog.dataset.predictiveUrl, window.location.origin);
      endpoint.search = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search'
      }).toString();
      results.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(endpoint, { signal: controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Suggestions unavailable');
        const html = await response.text();
        if (sequence !== requestSequence || !searchDialog.open) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const markup = parsed.querySelector('[data-predictive-response]');
        if (!markup) throw new Error('Suggestions unavailable');
        // Only insert our same-origin Liquid section; never assemble HTML from a query.
        results.replaceChildren(...Array.from(markup.childNodes));
        results.querySelectorAll('[data-predictive-option]').forEach(option => {
          option.tabIndex = -1;
          option.addEventListener('pointerenter', () => selectOption(options().indexOf(option)));
        });
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        const total = results.querySelectorAll('.ww-predictive-product, .ww-predictive-collection').length;
        status.textContent = total ? `${total} suggestions. Use the up and down arrows to explore.` : 'No suggestions yet. Try another word or search the full store.';
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== requestSequence) return;
        resetResults();
        status.textContent = 'Suggestions are temporarily unavailable. Press Search to see full results.';
      } finally {
        if (sequence === requestSequence) results.removeAttribute('aria-busy');
      }
    }
    input.addEventListener('input', scheduleSearch);
    input.addEventListener('keydown', event => {
      if (results.hidden || !options().length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = activeIndex < 0 ? (direction > 0 ? 0 : options().length - 1) : (activeIndex + direction + options().length) % options().length;
        selectOption(nextIndex);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        options()[activeIndex].click();
      }
    });
  }
  function initialize() { document.querySelectorAll('[data-ww-header]').forEach(initializeHeader); }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
